<div class="w-full space-y-6">
  <!-- Profile Card -->
  <p-card header="Profile" class="shadow-lg">
    <div class="flex items-start justify-between mb-6">
      <div class="flex items-center space-x-4">
        <!-- Avatar -->
        <div class="w-16 h-16 bg-gray-300 rounded-full flex items-center justify-center">
          <i class="pi pi-user text-2xl text-gray-600"></i>
        </div>
        
        <!-- User Info -->
        <div>
          <h2 class="text-2xl font-semibold text-gray-800">{{ profile.fullName }}</h2>
          <p class="text-gray-600">{{ profile.email }}</p>
        </div>
      </div>
      
      <!-- Edit Button -->
      <button pButton type="button" class="bg-sky-500 text-white px-4 py-2 rounded-md"
        [label]="isEditing ? 'Cancel' : 'Edit'" 
        [icon]="isEditing ? 'pi pi-times' : 'pi pi-pencil'"
        (onClick)="isEditing ? cancelEdit() : toggleEdit()">
      </button>
    </div>

    <!-- Profile Form -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Full Name -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Full Name</label>
        <input 
          pInputText 
          [(ngModel)]="profile.fullName" 
          [readonly]="!isEditing"
          class="w-full"
          [class.bg-gray-50]="!isEditing">
      </div>

      <!-- Display Name -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Display Name</label>
        <input 
          pInputText 
          [(ngModel)]="profile.displayName" 
          [readonly]="!isEditing"
          class="w-full"
          [class.bg-gray-50]="!isEditing">
      </div>

      <!-- Gender -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Gender</label>
        <select 
          [(ngModel)]="profile.gender"
          [disabled]="!isEditing"
          class="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
          [class.bg-gray-50]="!isEditing">
          <option *ngFor="let option of genderOptions" [value]="option.value">{{ option.label }}</option>
        </select>
      </div>

      <!-- State -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">State</label>
        <input 
          pInputText 
          [(ngModel)]="profile.state" 
          [readonly]="!isEditing"
          class="w-full"
          [class.bg-gray-50]="!isEditing">
      </div>

      <!-- Time Zone -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Time zone</label>
        <select 
          [(ngModel)]="profile.timezone"
          [disabled]="!isEditing"
          class="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
          [class.bg-gray-50]="!isEditing">
          <option *ngFor="let option of timezoneOptions" [value]="option.value">{{ option.label }}</option>
        </select>
      </div>

      <!-- Country/Region -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Country/Region</label>
        <select 
          [(ngModel)]="profile.country"
          [disabled]="!isEditing"
          class="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
          [class.bg-gray-50]="!isEditing">
          <option *ngFor="let option of countryOptions" [value]="option.value">{{ option.flag }} {{ option.label }}</option>
        </select>
      </div>

      <!-- Language -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Language</label>
        <select 
          [(ngModel)]="profile.language"
          [disabled]="!isEditing"
          class="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
          [class.bg-gray-50]="!isEditing">
          <option *ngFor="let option of languageOptions" [value]="option.value">{{ option.label }}</option>
        </select>
      </div>
    </div>

    <!-- Save Button -->
    <div *ngIf="isEditing" class="flex justify-end mt-6">
      <p-button 
        label="Save Changes" 
        icon="pi pi-check"
        severity="success"
        (onClick)="saveProfile()">
      </p-button>
    </div>
  </p-card>

  <!-- Email Addresses Card -->
  <p-card header="My Email Addresses" class="shadow-lg">
    <div class="mb-4">
      <p class="text-gray-600">
        View and manage the email addresses associated with your account. They can be used to sign in and to reset password if you ever forget it.
      </p>
    </div>

    <!-- Email List -->
    <div class="space-y-4">
      <div *ngFor="let email of emails" class="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
        <div class="flex items-center space-x-4">
          <!-- Email Icon -->
          <div class="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center">
            <i class="pi pi-envelope text-pink-600"></i>
          </div>
          
          <!-- Email Info -->
          <div>
            <div class="font-medium text-gray-800">{{ email.address }}</div>
            <div class="text-sm text-gray-500">{{ email.addedDate }}</div>
          </div>
          
          <!-- Provider Icons -->
          <div class="flex items-center space-x-1">
            <span *ngIf="email.providers.includes('w')" class="w-6 h-6 bg-blue-100 rounded flex items-center justify-center">
              <span class="text-xs font-bold text-blue-600">W</span>
            </span>
            <i *ngIf="email.providers.includes('google')" class="pi pi-google text-red-500"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Email Button -->
    <div class="flex justify-end mt-4">
      <p-button 
        label="+ Add Email Address" 
        icon="pi pi-plus"
        severity="info"
        [text]="true"
        (onClick)="addEmailAddress()">
      </p-button>
    </div>
  </p-card>
</div>